import { todayPT } from "@homebound/activesupport";
import { RouteTabWithContent, TabContent, Tabs } from "@homebound/beam";
import { FinancesPageSharedQuery, useFinancesPageSharedQuery } from "src/routes/billing/FinancesPage.generated";
import { BillsPage } from "src/routes/bills/BillsPage";
import { InvoicesPage } from "src/routes/invoices/InvoicesPage";
import { PageHeader } from "src/routes/layout/PageHeader";
import {
  billsRoute,
  invoiceTermsRoute,
  invoicesRoute,
  lienWaiversRoute,
  purchaseOrdersRoute,
} from "src/routing/domains/financesPaths";
import { DateFilterOperation, queryResult } from "src/utils";
import { PurchaseOrdersPage } from "../developments/purchase-orders/PurchaseOrdersPage";
import { LienWaiversPage } from "../lien-waivers/LienWaiversPage";
import { InvoiceTermsPage } from "./invoice-terms/InvoiceTermsPage";

export function FinancesPage() {
  const query = useFinancesPageSharedQuery();
  return queryResult(query, { data: (data) => <FinancesPageFilterDataView shared={data} /> });
}

type FinancesPageFilterDataViewProps = { shared: FinancesPageSharedQuery };

function FinancesPageFilterDataView({ shared }: FinancesPageFilterDataViewProps) {
  const tabs: RouteTabWithContent[] = [
    {
      name: "Bills & Credits",
      href: billsRoute.url(),
      path: billsRoute.path,
      render: () => <BillsPage shared={shared} />,
    },
    {
      name: "Invoices",
      href: invoicesRoute.url(),
      path: invoicesRoute.path,
      render: () => <InvoicesPage shared={shared} />,
    },
    {
      name: "Purchase Orders",
      href: purchaseOrdersRoute.url(),
      path: purchaseOrdersRoute.path,
      render: () => <PurchaseOrdersPage isGlobal={true} />,
    },
    {
      name: "Invoice Terms",
      href: invoiceTermsRoute.url(),
      path: invoiceTermsRoute.path,
      render: () => <InvoiceTermsPage />,
    },
    {
      name: "Lien Waivers",
      href: lienWaiversRoute.url(),
      path: lienWaiversRoute.path,
      render: () => <LienWaiversPage shared={shared} />,
    },
  ];

  return (
    <>
      <PageHeader title="Finances" hideTitle left={<Tabs tabs={tabs} />} />
      <TabContent tabs={tabs} />
    </>
  );
}

export const financesDefaultFilter = {
  dueDate: { op: DateFilterOperation.Before, value: todayPT().add({ months: 1 }) },
};
